/**
 * Parents Service - API для управления родителями
 */

const API_BASE = '/api/parents';

/**
 * Получить список родителей
 */
export async function getParents({ page = 1, pageSize = 25, search = null, isActive = null, signal = null } = {}) {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('page_size', pageSize);
  if (search) params.append('search', search);
  if (isActive !== null) params.append('is_active', isActive);

  const response = await fetch(`${API_BASE}?${params}`, { credentials: 'include', signal });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to fetch parents');
  }
  return response.json();
}

/**
 * Получить родителя по ID
 */
export async function getParent(parentId) {
  const response = await fetch(`${API_BASE}/${parentId}`, { credentials: 'include' });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to fetch parent');
  }
  return response.json();
}

/**
 * Создать родителя (менеджером)
 */
export async function createParent(data) {
  const response = await fetch(API_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to create parent');
  }
  return response.json();
}

/**
 * Самостоятельная регистрация родителя (публичный endpoint)
 */
export async function registerParent(data) {
  const response = await fetch(`${API_BASE}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to register');
  }
  return response.json();
}

/**
 * Обновить родителя
 */
export async function updateParent(parentId, data) {
  const response = await fetch(`${API_BASE}/${parentId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to update parent');
  }
  return response.json();
}
